export const uiSchema = t => {
  return {
    wellbeingServiceTypes: {
      items: {
        id: {
          "ui:options": {
            hidelabel: true,
          },
        },
      },
      "ui:field": "multi-select",
    },
    isActive: {
      "ui:title": "Status",
      "ui:widget": "toggle",
      "ui:options": {
        labels: [
          { label: t("ENABLE"), value: true },
          { label: t("DISABLE"), value: false },
        ],
      },
    },
    aboutTheService: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5,
      },
    },
    activeFrom: {
      "ui:widget": "hidden",
    },
    activeTo: {
      "ui:widget": "hidden",
    },
    howToAccess: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5,
      },
    },
  };
};
